import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Table } from 'antd';
import Header from './header';
import Sidebar from './sidebar';
import { loadGoogleMaps } from '../utils/loadGoogleMaps';

const HouseDetails = () => {
  const { id } = useParams();
  const [houseDetails, setHouseDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHouseDetails = async () => {
      try {
        const response = await axios.get(`https://ward3-chandrapur-api.palikaapp.com/api/house/${id}/details`);
        setHouseDetails(response.data[0]);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchHouseDetails();
  }, [id]);

  useEffect(() => {
    if (houseDetails && houseDetails.latitude && houseDetails.longitude) {
      const initMap = async () => {
        try {
          const googleMaps = await loadGoogleMaps('AIzaSyB4Z418MHwoKYfrN9wq28zZvgqtfwmNXa4');
          const map = new googleMaps.Map(document.getElementById('houseMap'), {
            zoom: 15,
            center: {
              lat: parseFloat(houseDetails.latitude),
              lng: parseFloat(houseDetails.longitude),
            },
            mapTypeId: 'terrain',
          });

          new googleMaps.Marker({
            position: {
              lat: parseFloat(houseDetails.latitude),
              lng: parseFloat(houseDetails.longitude),
            },
            map,
            title: houseDetails.ownerNameEng,
          });
        } catch (error) {
          console.error('Failed to load Google Maps:', error);
        }
      };

      initMap();
    }
  }, [houseDetails]);

  if (loading) {
    return <div className="text-center text-blue-500 mt-10">Loading...</div>;
  }
  if (error) {
    return <div className="text-center text-red-500 mt-10">Error: {error.message}</div>;
  }

  const columns = [
    { title: 'क्र.सं.', dataIndex: 'id', key: 'id' },
    { title: 'परिवार मुलीको नाम', dataIndex: 'ownerNameNep', key: 'ownerNameNep' },
    { title: 'फोन', dataIndex: 'phone', key: 'phone' },
    { title: 'इमेल', dataIndex: 'email', key: 'email' },
  ];

  return (
    <div>
      <Header />
      <div className='pt-20 bg-gray'>
      <div className="flex">
        <Sidebar />
        <div className="flex-1 mt-20 ml-64 lg:ml-80 lg:mt-24 bg-white-100 min-h-screen" style={{minHeight:"calc(100vh-60px)"}}>
          <div className="bg-gray-100 shadow-md rounded-lg p-6 max-w-4xl mx-auto">
            <h2 className="text-center text-2xl font-semibold text-gray-700 mb-4 border-b pb-2">
              घरको विवरण
            </h2>
            {houseDetails && (
              <div>
                <p>
                  <strong className="text-blue-600">घरधनीको नाम (English):</strong>{' '}
                  {houseDetails.ownerNameEng}
                </p>
                <p>
                  <strong className="text-blue-600">घरधनीको नाम (नेपाली):</strong>{' '}
                  {houseDetails.ownerNameNep}
                </p>
                <p><strong className='text-blue-600'>नागरिकता नं:</strong> {houseDetails.citizenshipNo}</p>
                                <p><strong className='text-blue-600'>अक्षांश:</strong>{houseDetails.latitude}</p>
                                <p><strong className='text-blue-600'>देशान्तर:</strong> {houseDetails.longitude}</p>
                                <p><strong className='text-blue-600'>घरको प्रकार:</strong> {houseDetails.houseType}</p>
                                <p><strong className='text-blue-600'>घरको बर्ग:</strong> {houseDetails.houseCategory}</p>
                                <p><strong className='text-blue-600'>बनाको बर्ष:</strong> {houseDetails.buildYear}</p>
                                <p><strong className='text-blue-600'>तल्ल:</strong> {houseDetails.floor}</p>
                                <p><strong className='text-blue-600'>लम्बाई(अगाडी):</strong> {houseDetails.frontLength} meters</p>
                                <p><strong className='text-blue-600'>चौडाइ(पिछाड):</strong> {houseDetails.backWidth} meters</p>
                                <p><strong className='text-blue-600'>Google Plus Code:</strong> {houseDetails.googlePlusCode}</p>
                                <p><strong className='text-blue-600'>वडा:</strong> {houseDetails.munWardName}</p>
                                <p><strong className='text-blue-600'>टोल:</strong> {houseDetails.munToleName}</p>
                {/* Add more details */}
                {houseDetails.familyOwner && houseDetails.familyOwner.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={houseDetails.familyOwner}
                    rowKey="id"
                    bordered
                    className="custom-table"
                  />
                ) : (
                  <p>No family owner details available</p>
                )}
              </div>
            )}

            <div
              id="houseMap"
              className="h-80 w-full mt-4 rounded-lg shadow-lg"
            ></div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default HouseDetails;
